import { render, staticRenderFns } from "./MobileAppBar.vue?vue&type=template&id=22dc1ddc&"
import script from "./MobileAppBar.vue?vue&type=script&lang=ts&"
export * from "./MobileAppBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports